import { render } from "./ArchiveReportTabs.vue?vue&type=template&id=6dd1a76c"
import script from "./ArchiveReportTabs.vue?vue&type=script&lang=js"
export * from "./ArchiveReportTabs.vue?vue&type=script&lang=js"

import "./ArchiveReportTabs.vue?vue&type=style&index=0&id=6dd1a76c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__